import { handleSetSelectedIndexLevel } from "./handleSetSelectedIndexLevel";
import { getIndividualGroup } from "./getIndividualGroup";
import { useSitesPageStore } from "../sitesPageStore/sitesPageStore";

export const handleNestedLevelClick = async (
  setPage: any,
  setCurrentTitle: any,
  name: string,
  id: any,
  selectedIndex: any,
  levelName: any,
  setSelectedIndex: any,
  setRenderedRows: any,
  setPageLoading: any,
  navigate: any,
  setSiteBreadcrumbs: any,
  setSelected: any,
  setSelectedGroupListName: any,
  setEditableGroupSelected: any,
  expandClick: boolean
) => {
  const setSearchGroupId = useSitesPageStore.getState().setSearchGroupId;

  if (expandClick) {
    setEditableGroupSelected(true);
    setSelectedGroupListName(name);
    setSiteBreadcrumbs("");
    setPage(0);
    setCurrentTitle(name);
    localStorage.setItem("getIndividualGroupId", id);
    setSearchGroupId(id);
    getIndividualGroup(
      id,
      setRenderedRows,
      setPageLoading,
      setSiteBreadcrumbs,
      setSelected,
      setEditableGroupSelected,
      setSelectedGroupListName,
      navigate
    );
  }
  handleSetSelectedIndexLevel(selectedIndex, levelName, id, setSelectedIndex);
};
